import React from 'react'

import Heading from '../../atoms/Typography/Heading'
import Row from '../../atoms/Row'
import Col from '../../atoms/Col'
import Link from '../../atoms/Link'
import RelatedLinks from '../../atoms/RelatedLinks'

export default ({ title, nonMarketPages = [] }) =>
  nonMarketPages.length > 0 ? (
    <RelatedLinks>
      <Heading as='h4'>{title}</Heading>
      <Row>
        {nonMarketPages.map((page, i) => (
          <Col key={i}>
            <Link href={page.slug}>{page.shortTitle || page.title}</Link>
          </Col>
        ))}
      </Row>
    </RelatedLinks>
  ) : null
